"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_PRODUCTION: function() {
        return ADD_PRODUCTION;
    },
    DELETE_PRODUCTION: function() {
        return DELETE_PRODUCTION;
    },
    DUPLICATE_PRODUCTION: function() {
        return DUPLICATE_PRODUCTION;
    },
    GENERATE_PRODUCTIONS: function() {
        return GENERATE_PRODUCTIONS;
    },
    PRODUCTION_COMPLETE: function() {
        return PRODUCTION_COMPLETE;
    },
    PRODUCTION_COMPLETE_BRANDS: function() {
        return PRODUCTION_COMPLETE_BRANDS;
    },
    PRODUCTION_COMPLETE_CHAMPIONSHIPS: function() {
        return PRODUCTION_COMPLETE_CHAMPIONSHIPS;
    },
    PRODUCTION_COMPLETE_SEGMENTS: function() {
        return PRODUCTION_COMPLETE_SEGMENTS;
    },
    PRODUCTION_COMPLETE_WRESTLERS: function() {
        return PRODUCTION_COMPLETE_WRESTLERS;
    },
    PRODUCTION_SEGMENTS_SIMULATE: function() {
        return PRODUCTION_SEGMENTS_SIMULATE;
    },
    RESET_PRODUCTIONS: function() {
        return RESET_PRODUCTIONS;
    },
    UPDATE_PRODUCTION: function() {
        return UPDATE_PRODUCTION;
    }
});
const ADD_PRODUCTION = "ADD_PRODUCTION";
const UPDATE_PRODUCTION = "UPDATE_PRODUCTION";
const DELETE_PRODUCTION = "DELETE_PRODUCTION";
const GENERATE_PRODUCTIONS = "GENERATE_PRODUCTIONS";
const RESET_PRODUCTIONS = "RESET_PRODUCTIONS";
const DUPLICATE_PRODUCTION = "DUPLICATE_PRODUCTION";
const PRODUCTION_COMPLETE = "PRODUCTION_COMPLETE";
const PRODUCTION_COMPLETE_SEGMENTS = "PRODUCTION_COMPLETE_SEGMENTS";
const PRODUCTION_COMPLETE_WRESTLERS = "PRODUCTION_COMPLETE_WRESTLERS";
const PRODUCTION_COMPLETE_CHAMPIONSHIPS = "PRODUCTION_COMPLETE_CHAMPIONSHIPS";
const PRODUCTION_COMPLETE_BRANDS = "PRODUCTION_COMPLETE_BRANDS";
const PRODUCTION_SEGMENTS_SIMULATE = "PRODUCTION_SEGMENTS_SIMULATE";
